// Re-export ShareModal as InvoiceShareModal for backward compatibility
import { ShareModal } from './ShareModal';

interface InvoiceShareModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSent?: () => void;
    shareUrl: string;
    recipientPhone: string;
    recipientName: string;
    recipientEmail?: string;
    invoiceNumber: string;
    isFullyPaid?: boolean;
    amountLabel?: string;
    jobId?: string;
}

export function InvoiceShareModal({
    isOpen,
    onClose,
    onSent,
    shareUrl,
    recipientPhone,
    recipientName,
    recipientEmail = '',
    invoiceNumber,
    isFullyPaid = false,
    amountLabel,
    jobId,
}: InvoiceShareModalProps) {
    return (
        <ShareModal
            isOpen={isOpen}
            onClose={onClose}
            onSent={onSent}
            shareUrl={shareUrl}
            recipientPhone={recipientPhone}
            recipientName={recipientName}
            recipientEmail={recipientEmail}
            entityType="invoice"
            entityNumber={invoiceNumber}
            isFullyPaid={isFullyPaid}
            amountLabel={amountLabel}
            jobId={jobId}
        />
    );
}

export default InvoiceShareModal;
